export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    image: null,
    content: {
      identifier: '',
      title: '',
      content: '',
      image: null,
    },
  }
}
